import {
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
} from '@nextui-org/react';
import React from 'react';
import { ICubage } from '../../../interfaces/response/Cubage/ICubage';
import useCubageTable from './hooks/useCubageTable';

export interface ICubageTable {
  cubages: ICubage[];
  onRowClick?: (Cubage: ICubage) => void;
}

const CubageTable: React.FC<ICubageTable> = ({
  cubages,
  onRowClick,
}): JSX.Element => {
  const {
    cellData,
    columns,
    handleRowClick,
    setSortDescriptor,
    sortDescriptor,
    sortedLocationsPrices,
  } = useCubageTable({
    cubages,
    onRowClick,
  });

  return (
    <Table
      aria-label="Tabela de tabelas preço"
      selectionMode="single"
      onRowAction={handleRowClick}
      sortDescriptor={sortDescriptor}
      onSortChange={setSortDescriptor}
    >
      <TableHeader columns={columns}>
        {({ key, name }) => (
          <TableColumn key={key} allowsSorting>
            {name}
          </TableColumn>
        )}
      </TableHeader>

      <TableBody
        items={sortedLocationsPrices}
        emptyContent="Nenhuma tabela preço no momento"
      >
        {(item) => (
          <TableRow key={item.idCubagem}>
            {(columnKey) => (
              <TableCell>
                <p className="text-foreground-600">
                  {cellData(item, columnKey as string)}
                </p>
              </TableCell>
            )}
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};

export default CubageTable;
